import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  root: {},

  rootText: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(2),
      width: '100%',
      height: theme.spacing(3),
    },
  },
}));

export {useStyles}

